import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";

import LoginPage from "pages/login";
import ChatsPage from "pages/chats";
import ChatPage from "pages/chat";
import HomePage from "pages/home";
import ProfilePage from "pages/profile";
import HistoryPage from "pages/history";
import RootPage from "pages/root";
import ReportPage from "pages/report";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/">
      <Route index Component={RootPage} />
      <Route Component={HomePage}>
        <Route path="/chats">
          <Route index Component={ChatsPage} />
        </Route>
        <Route path="/history">
          <Route index Component={HistoryPage} />
        </Route>
        <Route path="/profile">
          <Route index Component={ProfilePage} />
        </Route>
        <Route path="/active_chat">
          <Route index Component={ChatPage} />
        </Route>
        <Route path="/reports/:reportId" Component={ReportPage} />
      </Route>
      <Route path="/login" Component={LoginPage}></Route>
    </Route>
  )
);

export default router;
